module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/003-austria-2152caf4598ae9937780dfdace032639.svg";